import React, { useEffect, useState, useContext } from "react";
import { Col, Container, Input, Row } from "reactstrap";
import Toggler from "../../../component/ToggleSwitch";
import Bmi from "./Bmi";
import NumberFormat from 'react-number-format';
import { 
  convertFeetToCm, 
  convertCmToFeet, 
  convertLbsToKgs, 
  convertKgsToLbs, 
  weightOptions, 
  heightOptions, calculateBMI 
} from './Calculator';

const feetTextboxFormat = "# ft ## in";

const HeightWidth = ({user}) => {

	const [weight, setWeight] = useState(user.weight);
	const [height, setHeight] = useState(user.height);
	const [weightUnit, setWeightUnit] = useState(user.weightUnit);
	const [heightUnit, setHeightUnit] = useState(user.heightUnit);
	const [calculatedBmi, setCalculatedBmi] = useState(0);

	useEffect(() => {
		
		const BMI = calculateBMI(weight, weightUnit, height, heightUnit);
		setCalculatedBmi(BMI);
		const bmiObj = { 
			bmi: BMI,
			weight: weight,
			weightUnit: weightUnit,
			height: height,
			heightUnit: heightUnit
		}
		localStorage.setItem('tempBmi', JSON.stringify(bmiObj));
		
	},[weight, height]);


	const weightUnitToggle = newUnit => {
		setWeightUnit(newUnit);
		if(newUnit === 'kg')
			setWeight(convertLbsToKgs(weight));
		else
			setWeight(convertKgsToLbs(weight));
	}


	const heightUnitToggle = newUnit => {
		setHeightUnit(newUnit);
		if(newUnit === 'cm') 
			setHeight(convertFeetToCm(height));
		else
			setHeight(convertCmToFeet(height));
	}


	return(<>
		<Container className="mt-5">
			<Row>
				<Col className="text-end pe-4">
					<Input 
						pattern="[0-9]*"
						type="number" 
						className="height-weight-input" 
						value={weight} 
						onChange={(e) => {
								if(e.target.value.length < 4)
									setWeight(e.target.value)}
							} />
				</Col>
				<Col xs={7}>
					<Toggler
					options={weightOptions}
					initialSelectedIndex={user.weightUnit}
					onChangeHandler={weightUnitToggle}
					name={'weight'} />
				</Col>
			</Row>
			<Row className="mt-5">
				<Col className="text-end pe-4">
					{heightUnit === 'cm' ?
						<Input 
						pattern="[0-9]*"
						type="number" 
						className="height-weight-input" 
						value={height} 
						onChange={(e) => {
							if(e.target.value.length < 4)
								setHeight(e.target.value)
						}
						} />
						 :
						<NumberFormat 
							format={feetTextboxFormat}
							className="form-control height-weight-input" value={height}
							onValueChange={(values) => {
							const { value } = values;
								var value1 = value.slice(0, 1) + "." + value.slice(1);
								setHeight(value1);
							}}/>
					}
				</Col>
				<Col xs={7}>
					<Toggler
					options={heightOptions}
					initialSelectedIndex={user.heightUnit}
					onChangeHandler={heightUnitToggle}
					name={'height'}
					/>
				</Col>
			</Row>
			<hr className="bmi-hr mt-5 mb-5" />
			<Bmi calculatedBmi={calculatedBmi} />
		</Container>
	</>)
};

export default HeightWidth;